import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const user = await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.message || 'Login failed. Check your credentials.');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1>BloansBooks</h1>
          <p>Bloans Creations Ltd</p>
        </div>
        {error && <div className="alert alert-error" style={{marginBottom:20}}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email address</label>
            <input type="email" className="form-control"
              placeholder="you@bloanshandbags.com"
              value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{position:'relative'}}>
              <input type={showPw?'text':'password'} className="form-control"
                value={password} onChange={e => setPassword(e.target.value)}
                required style={{paddingRight:52}} />
              <button type="button" onClick={() => setShowPw(!showPw)}
                style={{position:'absolute',right:12,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--ink-light)',fontSize:12,fontWeight:500}}>
                {showPw ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right',
              marginTop: -8,
              marginBottom: 12
            }}
          >
            <Link
              to="/forgot-password"
              style={{
                color: 'var(--forest)',
                fontSize: 12,
                fontWeight: 600
              }}
            >
              Forgot password?
            </Link>
          </div>
          <button type="submit" className="btn btn-primary"
            style={{width:'100%',justifyContent:'center',marginTop:8}} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
        <p className="text-muted text-sm" style={{textAlign:'center',marginTop:20}}>
          Contact your administrator if you need access.
        </p>
      </div>
    </div>
  );
}
